import { IMAGE_CDN_URL } from './constants';

/**
 * Ảnh placeholder inline (không cần request mạng) cho phim thiếu poster.
 * Dùng chính màu surface + accent của theme để không bị lệch tông.
 */
export const POSTER_PLACEHOLDER =
	'data:image/svg+xml;charset=utf-8,' +
	encodeURIComponent(
		`<svg xmlns="http://www.w3.org/2000/svg" width="300" height="420">
			<rect width="300" height="420" fill="#171b32"/>
			<circle cx="150" cy="186" r="44" fill="none" stroke="#ff5ca8" stroke-opacity=".5" stroke-width="3"/>
			<path d="M137 164l30 22-30 22z" fill="#ff5ca8" fill-opacity=".6"/>
			<text x="150" y="272" fill="#9b9db5" font-family="sans-serif" font-size="15" text-anchor="middle">Chưa có ảnh</text>
		</svg>`,
	);

/**
 * Endpoint list trả về đường dẫn tương đối ("uploads/movies/.../poster.webp"),
 * còn endpoint chi tiết trả URL tuyệt đối. Hàm này xử lý cả hai, và ưu tiên
 * `APP_DOMAIN_CDN_IMAGE` mà API gửi kèm trong từng response list.
 */
export function resolveImageUrl(
	path: string | undefined | null,
	cdnBase?: string,
): string {
	if (!path) return POSTER_PLACEHOLDER;
	if (/^https?:\/\//i.test(path)) return path;
	if (path.startsWith('data:')) return path;

	const base = (cdnBase ?? IMAGE_CDN_URL).replace(/\/+$/, '');
	return `${base}/${path.replace(/^\/+/, '')}`;
}
